type Method = 'reset' | 'page' | 'identify' | 'alias' | 'track';

export const createAnalyticsTracker = (debug: boolean) => (
  method: Method,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...contextArgs: any[]
) => {
  if (debug) {
    // eslint-disable-next-line no-console
    console.log(`analyticsTracker.${method}:`, ...contextArgs);
  }
  if (global.analytics) {
    global.analytics[method](...contextArgs);
  }
};
